import http from './http'
import store from '@/store'
// import _globa from './globa'// 引用文件
let base = window.SITE_CONFIG['forumURL']
let baseUrl = window.SITE_CONFIG['baseURL']

/**
 * 全局搜索-首页-全局搜索
 * @param {*} s
 */
export function globalSearch (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/globalSearch`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 商品选择 产品列表页-商品
 * @param {*} s
 */
export function goodDetailBuryingpoint (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/commodityChoice`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 类目选择-首页-产品类目导航一级
 * @param {*} s
 */
export function category (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/category`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 类目选择-首页-产品类目导航二级
 * @param {*} s
 */
export function categoryTwo (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/categoryTwo`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 类目选择-首页-产品类目导航二级
 * @param {*} s
 */
export function productCategory (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/productCategory`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 商品询价-产品详情-询价
 * @param {*} s
 */
export function commodityInquiry (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/commodityInquiry`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 商品收藏-产品详情-收藏
 * @param {*} s
 */
export function commodityCollection (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/commodityCollection`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 查看详情-首页-解决方案
 * @param {*} s
 */
export function homePageSolution (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/homePageSolution`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 解决方案详情-解决方案列表-点击详情
 * @param {*} s
 */
export function solutionDetail (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/solutionDetail`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 方案收藏-解决方案详情-方案收藏
 * @param {*} s
 */
export function programCollection (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/programCollection`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 方案咨询-解决方案详情-方案咨询
 * @param {*} s
 */
export function programmeAdvisory (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/programmeAdvisory`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 查看详情-首页-服务
 * @param {*} s
 */
export function professionalServices (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/professionalServices`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 服务详情-服务列表-点击详情
 * @param {*} s
 */
export function professionalServicesDetail (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/professionalServicesDetail`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 服务收藏-服务详情-服务收藏
 * @param {*} s
 */
export function professionalServicesCollection (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/professionalServicesCollection`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 服务咨询-服务详情-服务咨询
 * @param {*} s
 */
export function professionalServicesConsultation (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/professionalServicesConsultation`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 热卖分类-首页-热卖分类
 * @param {*} s
 */
export function hotCategories (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/hotCategories`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 热卖商品详情-首页-热卖分类-热卖商品
 * @param {*} s
 */
export function hotCategoriesDetail (keyWord) {
  http.post(`${base}/buryingpoint/buryingpoint/hotCategoriesDetail`, {
    keyWord: keyWord,
    userId: store.state.userInfo.userId
  })
}

/**
 * 知识社区首页-技术文档详情
 * @param {*} s
 */
export function technicalDocDetail (keyWord) {
  // http.post(`${base}/buryingpoint/buryingpoint/technicalDocDetail`, {
  //   keyWord: keyWord,
  //   userId: store.state.userInfo.userId
  // })
}

/**
 * 知识社区资料列表页-分类点击
 * @param {*} s
 */
export function technicalDocClassification (keyWord) {
  // http.post(`${base}/buryingpoint/buryingpoint/technicalDocClassification`, {
  //   keyWord: keyWord,
  //   userId: store.state.userInfo.userId
  // })
}

/**
 * 技术文档详情-收藏
 * @param {*} s
 */
export function technicalDocDetailCollection (keyWord) {
  // http.post(`${base}/buryingpoint/buryingpoint/technicalDocDetailCollection`, {
  //   keyWord: keyWord,
  //   userId: store.state.userInfo.userId
  // })
}

/**
 * 技术文档详情-下载
 * @param {*} s
 */
export function technicalDocDetailDownload (keyWord) {
  // http.post(`${base}/buryingpoint/buryingpoint/technicalDocDetailDownload`, {
  //   keyWord: keyWord,
  //   userId: store.state.userInfo.userId
  // })
}

/**
 * 技术视频详情-知识社区首页-技术视频详情
 * @param {*} s
 */
export function technicalvideoDetail (keyWord) {
  // http.post(`${base}/buryingpoint/buryingpoint/technicalvideoDetail`, {
  //   keyWord: keyWord,
  //   userId: store.state.userInfo.userId
  // })
}

/**
 * 视频分类点击-知识社区视频列表页-分类点击
 * @param {*} s
 */
export function technicalvideoClassification (keyWord) {
  // http.post(`${base}/buryingpoint/buryingpoint/technicalvideoClassification`, {
  //   keyWord: keyWord,
  //   userId: store.state.userInfo.userId
  // })
}

/**
 * 视频收藏-视频详情-收藏
 * @param {*} s
 */
export function technicalvideoDetaiCollection (keyWord) {
  // http.post(`${base}/buryingpoint/buryingpoint/technicalvideoDetaiCollection`, {
  //   keyWord: keyWord,
  //   userId: store.state.userInfo.userId
  // })
}

/**
 * 上传资料-知识社区首页-上传资料
 * @param {*} s
 */
export function uploadData (keyWord) {
  // http.post(`${base}/buryingpoint/buryingpoint/uploadData`, {
  //   keyWord: keyWord,
  //   userId: store.state.userInfo.userId
  // })
}

/**
 * 专家详情-专家列表-专家详情
 * @param {*} s
 */
export function expertDetail (keyWord) {
  // http.post(`${base}/buryingpoint/buryingpoint/expertDetail`, {
  //   keyWord: keyWord,
  //   userId: store.state.userInfo.userId
  // })
}

/**
 * 专家提问-专家列表-点击具体专家提问
 * @param {*} s
 */
export function expertPutQuestionsTo (keyWord) {
  // http.post(`${base}/buryingpoint/buryingpoint/expertPutQuestionsTo`, {
  //   keyWord: keyWord,
  //   userId: store.state.userInfo.userId
  // })
}

/**
 * 商品详情-商品详情-停留时间
 * @param {*} s
 */
export function commodityStayTimeSave (keyWord, stayTime) {
  http.post(`${base}/buryingpoint/buryingpoint/commodityStayTimeSave`, {
    keyWord: keyWord,
    stayTime: stayTime,
    userId: store.state.userInfo.userId
  })
}

/**
 * 解决方案-解决方案-详情停留时间
 * @param {*} s
 */
export function solutionStayTimeSave (keyWord, stayTime) {
  http.post(`${base}/buryingpoint/buryingpoint/solutionStayTimeSave`, {
    keyWord: keyWord,
    stayTime: stayTime,
    userId: store.state.userInfo.userId
  })
}

/**
 * 网站访问时间-通过浏览器地址输入网站/从外部连接进入网站
 * @param {*} s
 */
export function interviewTime (keyWord, stayTime) {
  http.post(`${base}/buryingpoint/buryingpoint/interviewTime`, {
    keyWord: keyWord,
    stayTime: stayTime,
    userId: localStorage.getItem('userId')
  })
}

/**
 * 扫码下载-安卓下载
 * @param {*} s
 */
export function androidSave () {
  http.post(`${base}/buryingpoint/buryingpoint/androidSave`)
}

// /**
//  * 扫码下载-IOS下载
//  * @param {*} s
//  */
// export function androidSave () {
//   http.post(`${base}/buryingpoint/buryingpoint/androidSave`)
// }

/**
 * 软件下载点击量
 * @param {*} s
 */
export function swClickCount (keyWord) {
  // http.post(`${base}/buryingpoint/buryingpoint/swClickCount`, {
  //   keyWord: keyWord,
  //   userId: localStorage.getItem('userId')
  // })
}

/**
 * 软件下载点击量
 * @param {*} s
 */
export function softWareCount (keyWord) {
  // http.post(`${base}/buryingpoint/buryingpoint/swDownload`, {
  //   keyWord: keyWord,
  //   userId: localStorage.getItem('userId')
  // })
}

/**
 *知识社区tab点击量
 * @param {*} s
 */
export function knowledgeCount () {
  // http.post(`${base}/buryingpoint/buryingpoint/buryingpointTab`, {
  //   keyWord: '知识社区tab点击',
  //   userId: store.state.userInfo.userId
  // })
}

/**
 *知识社区停留时间
 * @param {*} s
 */
export function knowledgeStayTime (time = 1) {
  // http.post(`${base}/buryingpoint/buryingpoint/buryingpointTabtime`, {
  //   keyWord: '知识社区首页停留时间',
  //   userId: store.state.userInfo.userId,
  //   stayTime: time
  // })
  // return
}

/**
 *培训tab点击量
 * @param {*} s
 */
export function trainingCount () {
  http.post(`${base}/buryingpoint/buryingpoint/trainingTab`, {
    keyWord: '培训tab点击',
    userId: store.state.userInfo.userId
  })
}

/**
 *培训停留时间
 * @param {*} s
 */
export function trainingStayTime (time = 1) {
  // http.post(`${base}/buryingpoint/buryingpoint/trainingTabTime`, {
  //   keyWord: '培训首页停留时间',
  //   userId: store.state.userInfo.userId,
  //   stayTime: time
  // })
}
/**
 *物资寻源tab点击量
 * @param {*} s
 */
export function materialSourceCount () {
  http.post(`${base}/buryingpoint/buryingpoint/materialSourcingTab`, {
    keyWord: '物资寻源tab点击',
    userId: store.state.userInfo.userId
  })
}

/**
 *物资寻源停留时间
 * @param {*} s
 */
export function materialSourceStayTime (time = 1) {
  http.post(`${base}/buryingpoint/buryingpoint/materialSourcingTime`, {
    keyWord: '物资寻源首页停留时间',
    userId: store.state.userInfo.userId,
    stayTime: time
  })
}
/**
 *远程管家tab点击量
 * @param {*} s
 */
export function butlerCount () {
  http.post(`${base}/buryingpoint/buryingpoint/remoteHousekeeperTab`, {
    keyWord: '远程管家tab点击',
    userId: store.state.userInfo.userId
  })
}

/**
 *远程管家停留时间
 * @param {*} s
 */
export function butlerStayTime (time = 1) {
  http.post(`${base}/buryingpoint/buryingpoint/remoteHousekeeperTime`, {
    keyWord: '远程管家首页停留时间',
    userId: store.state.userInfo.userId,
    stayTime: time
  })
}

/**
 *专项抢购的埋点
 * @param {*} s
 */
export function purchaseInfoBuringPoint (id, activityType = 1) {
  http.post(`/front/order/special/activity/statistics/save`, {
    'activityId': id,
    'activityType': activityType,
    'ip': window.SITE_CONFIG['returnCitySN'] ? window.SITE_CONFIG['returnCitySN'].cip : ''
  })
}
